import api from '../../api/api'

// initial state
const state = {
	all: null,
  status: {
    getAddons: null
  }
}

// getters
const getters = {}

// actions
const actions = {
  getAddons ({ commit, state }, params) {
    commit('setStatus', { getAddons: api.status.PENDING })
    return api.getAddons(params).then((response) => {
      commit('setAddons', response.data)
      commit('setStatus', { getAddons: api.status.SUCCESS })
    }).catch((error) => {
      commit('setStatus', { getAddons: api.status.FAILURE })
    })
  }
}

// mutations
const mutations = {
  setAddons (state, addons) {
    state.all = addons;
  },
  setStatus (state, status) {
    Object.assign(state.status, status)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
